var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "kpi-b" }, [
    _c("div", { staticClass: "flex-row flex-1" }, [
      _c("div", { staticClass: "flex-col flex-1" }, [
        _c(
          "div",
          {
            staticClass: "flex-row flex-1 mb-1 flex-justufy-center chart-title",
          },
          [_vm._v(" " + _vm._s(_vm.kpiBData.kpiName) + " ")]
        ),
        _c("div", { staticClass: "flex-row flex-justufy-center flex-1" }, [
          _c(
            "div",
            { staticClass: "flex-col flex-1 flex-end chart-title sub-header" },
            [_vm._v(" " + _vm._s(_vm.$t("actual")) + " ")]
          ),
          _c("div", { staticClass: "flex-col flex-1 chart-title ml-1" }, [
            _vm._v(" MTP " + _vm._s(_vm.yearLabel) + " "),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "flex-row flex-3 flex-justufy-center type-b-chart" },
          [_c("div", { attrs: { id: _vm.kpiBChartId } })]
        ),
      ]),
    ]),
    _c("div", { staticClass: "flex-row flex-justufy-center pr-2" }, [
      _c("div", { staticClass: "flex-col mr-3" }, [
        _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
          _c("div", { staticClass: "target rotate-90-degree mr-2" }, [
            _vm._v("|"),
          ]),
          _vm._v(" " + _vm._s(_vm.$t("target")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "flex-col flex-align-center mr-3" }, [
        _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
          _c("div", { staticClass: "peer rotate-90-degree mr-2" }, [
            _vm._v("|"),
          ]),
          _vm._v(" " + _vm._s(_vm.$t("peer")) + " "),
        ]),
      ]),
      _c("div", { staticClass: "flex-col flex-align-end mr-3" }, [
        _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
          _c("div", { staticClass: "asset rotate-90-degree mr-2" }, [
            _vm._v("|"),
          ]),
          _vm._v(" " + _vm._s(_vm.asset.name) + " "),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }